// src/components/pages/SignIn.js
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { signIn } from "../../services/authService";
import { getEventsForUser, createEvent } from "../../services/eventService"; // ← NEW
import languageMap from "../languageMap";
import "./SignIn.css";
import { Link } from "react-router-dom";
import Footer from "../Footer";



export default function SignIn() {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const lang = languageMap.config.selectedLanguage || "en";

  /* -------------- helpers -------------- */
  const makeStubEvent = async (userId) => {
    const todayIso = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
    return await createEvent({
      user_id:        userId,
      event_name:     "אירוע חדש",
      event_type:     "אירוע",
      intro_image_url:"",
      event_date:     todayIso,
      event_location: "מיקום לא מוגדר"
    });
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await signIn(username, password);
    

    if (result.success) {
      /* session info */
      localStorage.setItem("loggedInUser", username);
      localStorage.setItem("registeredUsername", username);
      localStorage.setItem("managementType", result.management_type || "photographer");
      localStorage.setItem("user_id", result.user_id );

      setResponseMessage(languageMap.signInSuccessMessage[lang]);

      /* route by role */
      if (result.management_type === "event_manager") {
        try {
          let events = await getEventsForUser(username);

          /* if no events – create one on the spot */
          if (events.length === 0) {
            const newEvent = await makeStubEvent(username);
            events = [newEvent];
          }

          /* redirect to gallery-manager with first event */
          history.push("/gallery-manager", { eventData: events[0] });
        } catch (err) {
          console.error("Redirect failed:", err);
          setResponseMessage("⚠️ שגיאה בטעינת האירועים");
        }
      } else {
        /* photographer flow */
        history.push("/events", { state: { username } });
      }
    } else {
      setResponseMessage(languageMap.signInFailureMessage[lang]);
    }

    setLoading(false);
  };

  /* -------------- ui -------------- */
  return (
    <div className="sign-in-page  blur-top blur-bottom blur-background">
      <div className="logo-container-sign">
        <Link to="/">
          <img src="/icons/logo.png" alt="Logo" className="logo" />
        </Link>
      </div>

      <div className="sign-in">
        <div className="sign-in-title">{languageMap.enterSignup[lang]}</div>

        <form onSubmit={handleSignIn} className="sign-in-form">
          <div className="form-group">
            <input
              type="text"
              value={username}
              placeholder={languageMap.signInUsernameLabel[lang]}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              value={password}
              placeholder={languageMap.signInPasswordLabel[lang]}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button className="signin-btn" type="submit" disabled={loading}>
            {loading ? "מתחבר" : languageMap.enter[lang]}
          </button>
        </form>

        {responseMessage && <p className="response-message">{responseMessage}</p>}


      </div>
      <Footer />
    </div>
    

  );

}
